import { NOT_SET, track } from '@/src/utils/tracking';
import { logError } from '@/src/logger';
import getOriginEvent from '@/src/utils/tracking/getOriginEvent';
import { getScreenName, getSortingSelect } from './utilsTracking';

const buildShopFilteringSelected = (specialTags = [], foodFilters = []) => {
  if (specialTags.length === 0 && foodFilters.length === 0) {
    return '--';
  }

  const formattedSpecialTags = specialTags
    .map((tag) => tag.replace(/-/g, '_'))
    .join(',');

  const formattedFoodFilters = foodFilters.join(',');

  return `${formattedSpecialTags}-${formattedFoodFilters}-`;
};

const shopListExpanded = (
  origin,
  page,
  pageShopQuantity,
  shopGoldVipPositions,
  shopGoldVip,
  businessType,
  shopQuantityShown,
  shopQuantityTotal,
  shopsIds,
  sortingSelected,
  selectedFilters = { specialTags: [], foodFilters: [] },
  isItemLanding = false,
) => {
  const EVENT_NAME = 'shop_list.expanded';

  try {
    const shopFilteringSelected = buildShopFilteringSelected(
      selectedFilters.specialTags,
      selectedFilters.foodFilters,
    );

    const payload = {
      action: 'enter_landing',
      origin: isItemLanding
        ? getOriginEvent(origin, isItemLanding).shopClickOrigin
        : 'global_organic_list',
      page,
      pageShopQuantity,
      screenType: isItemLanding ? 'items_landing' : 'vendors_landing',
      screenName: getScreenName(),
      shopGoldVipPositions:
        shopGoldVipPositions?.length > 0
          ? shopGoldVipPositions.join(',')
          : NOT_SET,
      shopGoldVip: shopGoldVip || 0,
      shopListBusinessType: businessType,
      shopQuantityShown: shopQuantityShown || NOT_SET,
      shopQuantityTotal: shopQuantityTotal || NOT_SET,
      shopsIds,
      sortingSelected: getSortingSelect(sortingSelected) || 'recommended',
      shopFilteringSelected,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default shopListExpanded;
